module.exports = __webpack_public_path__ + "img/graph_3.7f11e2b1.png";